module.exports = __webpack_public_path__ + "img/save-icon.0d105d6b.svg";